import SnsWhite from "@/assets/sns-white.svg";
import SnsLogo from "@/assets/sns-circle.svg";
import SeekerIcon from "@/assets/seeker-holder-icon.svg";
import WorldIcon from "@/assets/world.svg";
import type { DomainType } from "@/lib/types/api";

export function getCleanUsername(username?: string | null): string {
  if (!username) return "Anon";
  let cleaned = username.endsWith(".cfldotfun.sol")
    ? username.replace(".cfldotfun.sol", "")
    : username;
  // const maxLength = 15;
  // if (cleaned.length > maxLength) {
  //   cleaned = cleaned.slice(0, maxLength - 4) + "....";
  // }
  return cleaned;
}

export function getDomainTypeFromUsername(username?: string | null): DomainType {
  if (!username) return null;
  if (username.endsWith(".skr")) return "seeker";
  if (username.endsWith(".world.id")) return "world";
  return null;
}

export function getUserIconElement(domainType?: DomainType, size = "w-4 h-4") {
  if (!domainType) return null;

  if (domainType === "seeker") {
    return <img src={SeekerIcon} key="seeker" className={size} alt="Seeker" />;
  }

  if (domainType === "world") {
    return <img src={WorldIcon} key="world" className={size} alt="World" />;
  }

  return null;
}
